import * as React from "react";
const SvgPlusThick = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 1H6V6L1 6V10H6V15H10V10H15V6L10 6V1Z", fill: "currentColor" }));
export default SvgPlusThick;
